import { createStyles } from "@mantine/core"
import { mutateColorWhenLoggedInAsUser } from "@/components/TopNavigation/helpers"

export const useStyles = createStyles((theme, { loggedInAsUser }: { loggedInAsUser: boolean }) => ({
    quickActionButton: {
        padding: `${theme.spacing.sm} ${theme.spacing.md}`,
        marginRight: "0.75rem",
        border: 0,
        backgroundColor: theme.colors.violet[1],
        color: theme.colors.violet[8],
        "&:hover": {
            backgroundColor: mutateColorWhenLoggedInAsUser(theme.colors.violet[2], theme.colors.violet[3], {
                loggedInAsUser,
            }),
        },
        "&:active": {
            backgroundColor: "white",
            boxShadow: `0 0 0 2px ${theme.colors.violet[1]}`,
        },
        "&:focus": {
            backgroundColor: theme.colors.violet[2],
            color: theme.colors.violet[9],
            outline: "none",
            boxShadow: `0 0 0 0.125rem ${theme.colors.violet[5]}`,
        },
        "&[data-active]": {
            boxShadow: `0 0 0 2px ${theme.colors.violet[2]}`,
        },
    },

    dropdown: {
        padding: ".5rem 0",
        boxShadow: theme.shadows.xl,
    },

    buttonIcon: {
        padding: 0,
        margin: 0,
        marginRight: ".5rem",

        "&&": {
            height: "0.875rem",
            width: "0.875rem",
        },
    },

    buttonText: {
        fontSize: theme.fontSizes.sm,
        fontWeight: 500,
        color: theme.colors.violet[8],
    },

    itemContainer: {
        width: "15rem",
        margin: 0,
        padding: `${theme.spacing.sm} ${theme.spacing.md}`,
        borderRadius: 0,
        color: theme.colors.gray[7],
        "&:hover": {
            backgroundColor: theme.colors.violet[1],
            color: theme.colors.violet[8],
        },
        transition: "color .3s ease-in-out, background-color .3s ease-in-out, box-shadow .3s ease-in-out",
    },

    itemIcon: {
        padding: 0,
        margin: 0,
        marginRight: theme.spacing.xs,
        color: theme.colors.violet[8],
    },

    noActionContainer: {
        padding: `${theme.spacing.md} ${theme.spacing.xl}`,
        width: "15rem",
        minHeight: "10rem",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },

    noActionTitleText: {
        fontSize: theme.fontSizes.md,
        fontWeight: 500,
        color: theme.colors.gray[9],
        textAlign: "center",
        marginTop: "1rem",
        marginLeft: "auto",
        marginRight: "auto",
    },

    noActionSmallText: {
        fontSize: theme.fontSizes.sm,
        fontWeight: 400,
        color: theme.colors.gray[7],
        textAlign: "center",
        marginTop: "0.5rem",
        marginLeft: "auto",
        marginRight: "auto",
    },
}))
